<template>
	<el-date-picker
		v-model="hisDateFilter"
		type="daterange"
		align="right"
		size="mini"
		unlink-panels
		:clearable="true"
		range-separator="至"
		start-placeholder="开始日期"
		end-placeholder="结束日期"
		format="yyyy-MM-dd"
		:default-time="['00:00:00','23:59:59']"
		value-format="timestamp"
		:picker-options="hisPickerOptions"
	></el-date-picker>
</template>

<script>
export default {
	data() {
		return {
			hisDateFilter: null,
			hisPickerOptions: {
				shortcuts: [
					{
						text: "清空",
						onClick(picker) {
							picker.$emit("pick", null);
						}
					},
					{
						text: "最近一周",
						onClick(picker) {
							let end = new Date();
							let start = new Date();
							end.setHours(23, 59, 59, 999);
							start.setTime(end.getTime() - 3600 * 1000 * 24 * 7 + 1);
							picker.$emit("pick", [start, end]);
						}
					},
					{
						text: "本月",
						onClick(picker) {
							let end = new Date();
							let start = new Date();
							end.setHours(23, 59, 59, 999);
							start.setHours(0, 0, 0, 0);
							start.setDate(1);
							picker.$emit("pick", [start, end]);
						}
					},
					{
						text: "上月",
						onClick(picker) {
							let end = new Date();
							let start = new Date();
							let month = start.getMonth();
							if (month == 0) {
								start.setFullYear(start.getFullYear() - 1, 11, 1);
							} else {
								start.setMonth(month - 1, 1);
							}

							end.setDate(1);
							end.setHours(0, 0, 0, 0);
							end.setTime(end.getTime() - 1);

							picker.$emit("pick", [start, end]);
						}
					}
				]
			}
		};
	},
	computed: {},
	created() {},
	mounted() {},
	methods: {},
	props: {
		value: {
			type: Array
		},
		params: {
			type: Object,
			default: function() {
				return {
					range: 0,
					rangeMsg: ""
				};
			}
		}
	},
	watch: {
		hisDateFilter: function(val) {
			if (this.params.range > 0 && val[1] - val[0] > this.params.range) {
				this.$message.warning(this.params.rangeMsg);
				this.$nextTick(() => {
					this.hisDateFilter = [val[1] - this.params.range, val[1]];
				});
				return;
			}
			this.$emit("input", val);
		},
		value: function(val) {
			this.hisDateFilter = val;
		}
	},
	components: {}
};
</script>
<style lang="scss" scoped>
</style>
